import { Stack } from '@mui/material';
import { EntitlementsList } from './EntitlementsList';
import { SearchEntitlement } from './Search';
import { SelectedFilters } from './SelectedFilters';
import { FilterTags } from 'Modules/CompassRights/UserEntitlementsPanel/FilterTags';
import { useIsDesktop } from 'Hooks';

export const UserEntitlementsPanel = () => {
  const isDesktop = useIsDesktop();
  return (
    <Stack gap={'40px'}>
      <Stack gap={isDesktop ? '24px' : '40px'}>
        <SearchEntitlement />
        <FilterTags />
      </Stack>
      <SelectedFilters />
      <EntitlementsList />
    </Stack>
  );
};
